<template>
  <v-row justify="center" dense>
    <v-col cols="12" sm="6" md="4">
      <v-select
        :items="transportTypes"
        item-text="name"
        item-value="id"
        v-model="contextTransportType"
        :error-messages="modelTransportTypeValidation"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" v-if="modelTransportType !== 1">
      <v-select
        :items="settlementTypes(modelTransportType)"
        v-model="contextSettlementTypeId"
        v-bind:error-messages="modelSettlementTypeIdValidation"
        :label="$t('delegation.form.fields.transport.settlementType.name')"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4">
      <ajax-booking-flight-select
        v-if="modelTransportType === 2"
        :model.sync="contextBookingId"
        v-on:importRouteTo="importRouteTo"
        v-on:importRouteBack="importRouteBack"
        :validation-message="modelBookingIdValidation"
        :fileId.sync="contextFileId"
        v-on:fileUploaded="addFileToDelegationFiles"
        v-on:fileRemoved="removeFileFromDelegationFiles"
        :ticketNumber.sync="contextBookingTicket"
        :readonly="$store.state.Delegation.readonly === true"
      />
      <ajax-booking-rail-select
        v-if="modelTransportType === 3"
        :model.sync="contextBookingId"
        :fileId.sync="contextFileId"
        v-on:importRailRoute="importRailRoute"
        :validation-message="modelBookingIdValidation"
        v-on:fileUploaded="addFileToDelegationFiles"
        v-on:fileRemoved="removeFileFromDelegationFiles"
        :ticketNumber.sync="contextBookingTicket"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import SettlementTypes from "../../../../staticData/TransportSettlementTypes";
import AjaxBookingFlightSelect from "../../../CustomInputComponents/AjaxBookingFlightSelect.vue";
import AjaxBookingRailSelect from "../../../CustomInputComponents/AjaxBookingRailSelect.vue";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowTransportSettlementBookingSet",
  components: { AjaxBookingRailSelect, AjaxBookingFlightSelect },
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelFileId: {
      required: false
    },
    modelBookingId: {
      required: true
    },
    modelBookingTicket: {
      required: false,
      default: null
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelBookingIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.contextBookingId = null;
        this.contextBookingTicket = null;
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextBookingId: {
      set: function(value) {
        this.$emit("update:modelBookingId", value);
      },
      get: function() {
        return this.modelBookingId;
      }
    },
    contextBookingTicket: {
      set: function(value) {
        this.$emit("update:modelBookingTicket", value);
      },
      get: function() {
        return this.modelBookingTicket;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    contextFileId: {
      set: function(value) {
        this.$emit("update:modelFileId", value);
      },
      get: function() {
        return this.modelFileId;
      }
    }
  },
  methods: {
    settlementTypes: SettlementTypes,
    importRouteTo(item) {
      this.$emit("importRouteTo", item);
    },
    importRouteBack(item) {
      this.$emit("importRouteBack", item);
    },
    importRailRoute(item) {
      this.$emit("importRailRoute", item);
    },
    addFileToDelegationFiles(item) {
      const newItem = item;
      newItem.description = "Załącznik dotyczący transportu";
      newItem.category = "transport";
      this.$store.dispatch("Delegation/addFile", newItem);
    },
    removeFileFromDelegationFiles(item) {
      this.$store.dispatch("Delegation/removeFile", item.id);
    }
  }
};
</script>

<style scoped></style>
